import React from 'react';
import styles from './features.module.scss';

const features = () => (
  <div className={[styles.container].join(' ')}>
    <div className={styles.conditionBlock}>
      <div className={[styles.conditions, 'row'].join(' ')}>
        <div className={[styles.condition, 'col-12', 'col-md-12', 'col-xl-6'].join(' ')}>
          <div className={styles.conditionTitle}> 多本帳本 不同幣值</div>
          <p>不同主題分開記，成員相同也不會搞混。 </p>
          <p>輸入 <span>新帳本 ＋ 帳本名稱</span> 即可新增不同幣值帳本囉！</p>
        </div>
        <div className={[styles.condition, 'col-12', 'col-md-12', 'col-xl-6'].join(' ')}>
          <div className={styles.conditionTitle}> 建立虛擬使用者 </div>
          <p>臨時攜伴參加，不用額外開設新群組！
            <p>輸入
              <span>  新增使用者 名字Ａ 名字Ｂ</span>
              可一次新增多位使用者
            </p>
          </p>
        </div>
        <div className={[styles.condition, 'col-12', 'col-md-12', 'col-xl-6'].join(' ')}>
          <div className={styles.conditionTitle}> 分帳名單個別控管 </div>
          <p> 這次出遊你不參與？只要退出該帳本，不用退出群組</p>
          <p>輸入
            <span>  分帳 </span>
            來管理你的分帳名單！
          </p>
        </div>
        <div className={[styles.condition, 'col-12', 'col-md-12', 'col-xl-6'].join(' ')}>
          <div className={styles.conditionTitle}> 匯出CSV報表 </div>
          <p> 覺得龍寶寶算錯了嗎？一鍵匯出報表來驗證帳款！</p>
          <p>輸入
            <span>  驗算帳款 </span>
            即可將所有帳目匯出。
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default features;
